import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';

@Component({
  selector: 'app-date-time-field',
  templateUrl: './date-time-field.component.html',
  styleUrls: ['./date-time-field.component.scss'],
})
export class DateTimeFieldComponent implements OnInit {
  @Input() label: string;
  @Input() inputName: string;
  @Input() form: UntypedFormGroup;
  @Input() isError: boolean;
  @Input() placeholder: string;
  @Input() uniqueId: string;
  @Input() preValue: string;

  lastSelectedValue: any;
  isPickerOpen = false;

  constructor() {}

  get dtId(): string {
    return 'dt-' + this.uniqueId;
  }

  get displayValue(): string {
    const val = this.form.get(this.inputName)?.value;
    if (!val) return '';
    const d = new Date(val);
    if (isNaN(d.getTime())) return '';
    return (
      d.toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'}) +
      ' ' +
      d.toLocaleTimeString('en-GB', {hour: '2-digit', minute: '2-digit'})
    );
  }

  ngOnInit() {
    if (this.preValue) {
      this.form.get(this.inputName)?.setValue(this.convertDateTimeToISO(this.preValue));
      this.lastSelectedValue = this.convertDateTimeToISO(this.preValue);
    }
  }

  openPicker() {
    this.lastSelectedValue = this.form.get(this.inputName)?.value;
    this.isPickerOpen = true;
  }

  onModalDismiss() {
    this.isPickerOpen = false;
  }

  onCancelClick() {
    this.form.get(this.inputName)?.setValue(this.lastSelectedValue);
    this.isPickerOpen = false;
  }

  onConfirmClick() {
    try {
      const selected = this.form.get(this.inputName)?.value;
      if (!selected) {
        this.form.get(this.inputName)?.setValue(new Date().toISOString());
      }
      this.lastSelectedValue = this.form.get(this.inputName)?.value;
      this.isPickerOpen = false;
    } catch {
      this.lastSelectedValue = new Date().toISOString();
      this.isPickerOpen = false;
    }
  }

  convertDateTimeToISO(dateTimeString: string): string {
    const date = new Date(dateTimeString);
    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString().slice(0, -1);
  }
}
